/**
 * @generated SignedSource<<a44dbcfa01a6490d14822cf6b719760b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FundsTable_table$data = {
  readonly detailfilter: {
    readonly selectioninfo: {
      readonly resultTextPlural: string | null | undefined;
      readonly resultTextSingular: string | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"DetailFilter_detailFilter">;
  } | null | undefined;
  readonly entries: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly category: string | null | undefined;
        readonly country: string | null | undefined;
        readonly currency: string | null | undefined;
        readonly distribution: string | null | undefined;
        readonly fundsname: string | null | undefined;
        readonly id: string;
        readonly largeinvestmentfonds: number | null | undefined;
        readonly traits: ReadonlyArray<string | null | undefined> | null | undefined;
        readonly tranches: {
          readonly edges: ReadonlyArray<{
            readonly node: {
              readonly currency: string | null | undefined;
              readonly distribution: string | null | undefined;
              readonly id: string;
              readonly institutional: string | null | undefined;
              readonly isin: string | null | undefined;
              readonly salesadmission: ReadonlyArray<string | null | undefined> | null | undefined;
              readonly url: string | null | undefined;
            } | null | undefined;
          } | null | undefined> | null | undefined;
        } | null | undefined;
        readonly " $fragmentSpreads": FragmentRefs<"Fund_fund">;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly filterbuttontext: string | null | undefined;
  readonly filterbuttontextexpanded: string | null | undefined;
  readonly livefilter: {
    readonly " $fragmentSpreads": FragmentRefs<"LiveFilter_liveFilter">;
  } | null | undefined;
  readonly noResultsMessage: string | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"FundsTableHeader_header">;
  readonly " $fragmentType": "FundsTable_table";
};
export type FundsTable_table$key = {
  readonly " $data"?: FundsTable_table$data;
  readonly " $fragmentSpreads": FragmentRefs<"FundsTable_table">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "distribution",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currency",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FundsTable_table",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "FundsTableHeader_header"
    },
    {
      "alias": null,
      "args": (v0/*: any*/),
      "concreteType": "FundsConnection",
      "kind": "LinkedField",
      "name": "entries",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FundsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Funds",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v1/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "fundsname",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "category",
                  "storageKey": null
                },
                (v2/*: any*/),
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "country",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "traits",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "largeinvestmentfonds",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": (v0/*: any*/),
                  "concreteType": "TrancheConnection",
                  "kind": "LinkedField",
                  "name": "tranches",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "TrancheEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "Tranche",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "url",
                              "storageKey": null
                            },
                            (v3/*: any*/),
                            (v2/*: any*/),
                            (v1/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isin",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "institutional",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "salesadmission",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": "tranches(first:1000)"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Fund_fund"
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "entries(first:1000)"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DetailFilter",
      "kind": "LinkedField",
      "name": "detailfilter",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "DetailFilterSelectionInfo",
          "kind": "LinkedField",
          "name": "selectioninfo",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resultTextSingular",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "resultTextPlural",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "DetailFilter_detailFilter"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveFilter",
      "kind": "LinkedField",
      "name": "livefilter",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LiveFilter_liveFilter"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterbuttontext",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "filterbuttontextexpanded",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "noResultsMessage",
      "storageKey": null
    }
  ],
  "type": "FundsTable",
  "abstractKey": null
};
})();

(node as any).hash = "abb54bb10259a5a9f787b0f933b497da";

export default node;
